module.exports = __webpack_public_path__ + "static/media/Tab_Results_Active.220aaf15.png";